import { ResetPassSetInitGetRequestModel } from "@/features/user/services/reset-pass-set-model";
import { ResetPassSetApi } from "@/features/user/services/reset-pass-set-api";

// パスワードリセット パスワード設定ページ表示前処理
export class ResetPassSetService {
  private resetPassSetApi = new ResetPassSetApi();

  /**
   * パスワードリセット パスワード設定ページ表示前処理API実行
   */
  public async resetPassSetInit(param: ResetPassSetInitGetRequestModel) {
    return await this.resetPassSetApi.resetPassSetInit(param);
  }
}
